import { isNLD_OR_LL } from 'common/constants/app.constants';
import React from 'react';
import './progressComponent.scss';

const progressComponent = ({ noOfProcessingSites = '', percentageComplete = 0 }) => {
  const widthStyle = {
    width: `${percentageComplete}%`
  };

  return (
    <div className="site_progress">
      <div className="progress_counter">
        <span className="total_count">{noOfProcessingSites} </span>
        <span className="ttl_lable"> {isNLD_OR_LL() ? ' Links Processing...' : ' Sites Processing...'}</span>
      </div>
      <div className="progress_details">
        <div className="progress_text">{percentageComplete}% Complete</div>
        <div className="progress_bar">
          <span className="progress_strip" style={widthStyle}>
            {' '}
          </span>
        </div>
      </div>
    </div>
  );
};

export default progressComponent;
